import { ENDPOINTS } from "../../utils/endPoints";
import { GET_API_CALL, PUT_API_CALL } from "../../utils/services";
import {
  UPDATE_QUERIES_LIST_DATA,
  UPDATE_QUERIES_LOADING,
} from "../../store/actionTypes";
import { createParams } from "../../utils/commonFunctions";
import toast from "react-hot-toast";

/**
 * @description all actions related to queries
 * @returns response of Queries api
 */
export const fetchQueryList = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_QUERIES_LOADING });
    const { pageNo, limit, sortOrder, sortBy, status } =
      getState().QueriesReducer;
    const params = createParams({
      pageNo,
      limit,
      sortOrder,
      sortBy,
      status,
    });

    GET_API_CALL(ENDPOINTS.QUERIES.QUERY_LIST, params, (response) => {
      console.log("Queries List Response :", response);
      if (response?.isSuccess) {
        let { data, total, totalPage } = response?.data;
        dispatch({
          type: UPDATE_QUERIES_LIST_DATA,
          payload: {
            total,
            totalPage,
            queriesList: [...data],
          },
        });
      }
      dispatch({ type: UPDATE_QUERIES_LOADING });
    });
  };
};

export const queryStatusHandler = (params, callback) => {
  return () => {
    const toastId = toast.loading("Updating");
    PUT_API_CALL(ENDPOINTS.QUERIES.STATUS + params, {}, (response) => {
      console.log("query Active Inactive Response :", response);
      if (response.isSuccess) {
        callback(response);
        toast.success("query status updated successfully");
      }
      toast.dismiss(toastId);
    });
  };
};
